<mat-icon *ngIf="icon">{{icon}}</mat-icon>
<span [ngClass]="{'tag-text': this.icon}">{{text}}</span>
